<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ title }}</strong>
                    </div>
                    <div>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(assetInfoSync.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ assetInfoSync.syncUnitName }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tài khoản đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ assetInfoSync.syncUserName }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Ngày đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ assetInfoSync.syncDate | formatTime }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Thời gian thực hiện:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ assetInfoSync.elapsedTime }} ms</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Loại đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getAssetInfoSyncTypeName(assetInfoSync.infoType) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getStatusName(assetInfoSync.status ? 1 : 0) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Mã quá trình đồng bộ (UUID):"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ assetInfoSync.syncProcessId }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="form-group row" v-if="assetInfoSync.errorMessage">
                            <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Thông tin lỗi:</label>
                            <label class="text-danger col-8 col-md-10" style="padding-left: 7px">
                                {{ assetInfoSync.errorMessage }}
                            </label>
                        </div>
                        <div class="form-group row">
                            <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Dữ liệu gốc:</label>
                            <div class="col-8 col-md-10">
                                <json-viewer :data="assetInfoSync.rawData"></json-viewer>
                            </div>
                        </div>
                    </div>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :dataUrl="`logging/asset-info-sync-logs/${logId}/data`"
                            gridName="Danh sách dữ liệu được đồng bộ"
                            ref="assetSyncLogDataTable" v-if="logId">
                        <template v-slot:actions>
                            <b-form @submit.prevent="searchData">
                                <b-form-input v-model="searchForm.filter" placeholder="Mã/Tên tài sản"></b-form-input>
                            </b-form>
                        </template>
                        <template v-slot:cell(isValid)="row">
                            <span :class="row.item.isValid? 'text-success' : 'text-danger'">
                                {{ row.item.isValid? 'Thành công' : 'Thất bại' }}
                            </span>
                        </template>
                        <template v-slot:cell(syncTargetId)="row">
                            <router-link :to="{ path: getTargetPath(row.value) }" v-if="isLinkable">
                                {{ row.value }}
                            </router-link>
                            <span v-else>
                                {{ row.value }}
                            </span>
                        </template>
                        <template v-slot:cell(assetCode)="row">
                            <router-link :to="{ path: getAssetPath(row.item.assetTypeGroupId, row.item.assetId) }">
                                {{ row.value }}
                            </router-link>
                        </template>
                        <template v-slot:cell(errorMessage)="row">
                            <button size="sm" @click="showError(row.item, row.index, $event.target)" class="btn mr-2" style="box-shadow: none" v-if="row.value">
                                <i class="fa fa-exclamation-triangle" style="color: orangered" title="Xem chi tiết"></i>
                            </button>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button size="sm" @click="showDetail(row.item, row.index, $event.target)" class="mr-2" variant="info">
                                Xem
                            </b-button>
                        </template>
                        <!--<template v-slot:row-details="row">
                            <b-card>
                                <ul>
                                    <li v-for="(value, key) in JSON.parse(row.item.detailData)" :key="key" :title="key">{{ getKeyName(key) }}: {{ value }}</li>
                                </ul>
                                <b-button size="sm" @click="row.toggleDetails"><i class="fa fa-eye-slash"></i> Ẩn chi tiết</b-button>
                            </b-card>
                        </template>-->
                    </b-grid>
                    <div class="text-center">
                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" ok-only>
            <json-viewer :data="infoModal.content"></json-viewer>
        </b-modal>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'ListAssetSource',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    filter: null
                },
                gridOptions: {
                    fields: [
                        { key: 'syncSourceId', label: 'Mã dữ liệu từ phần mềm gốc', sortable: true },
                        { key: 'syncTargetId', label: 'Mã dữ liệu sau đồng bộ', sortable: true },
                        { key: 'syncAssetCode', label: 'Mã tài sản từ phần mềm gốc', sortable: true, sortDirection: 'asc', thAttr: { width: 160 } },
                        { key: 'assetCode', label: 'Mã tài sản tại kho', sortable: true, sortDirection: 'asc', thAttr: { width: 160 } },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'assetTypeName', label: 'Loại tài sản', sortable: true },
                        { key: 'assetUnitName', label: 'Đơn vị quản lý', sortable: true },
                        { key: 'isValid', label: 'Trạng thái dữ liệu', sortable: true },
                        { key: 'errorMessage', label: 'Thông báo lỗi', sortable: false, tdClass: 'failure-status' }
                    ],
                    sortBy: 'isValid',
                },
                assetInfoSync: {

                },
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                }
            }
        },
        computed: {
            logId() {
                return this.$route.params.logId;
            },
            ...mapState({
                assetComments: (state) => state.common.assetComments
            }),
            isLinkable() {
                return this.assetInfoSync.infoTypeId <= 7 || this.assetInfoSync.infoTypeId == 14 || this.assetInfoSync.infoTypeId == 15;
            }
        },
        created() {
            this.loadLogDetail();
            if (this.$route.meta.title) {
                this.title = this.$route.meta.title;
            }
        },
        methods: {
            loadLogDetail() {
                var vm = this;
                return this.$services.get(`logging/asset-info-sync-logs/${this.logId}`).done(data => {
                    //var rawData;
                    //try {
                    //    rawData = JSON.parse(data.rawData);
                    //for (var i = 0; i < rawData.ASSET_INFO_SYNC_LOG_DATA.length; i++) {
                    //    if (typeof (rawData.ASSET_INFO_SYNC_LOG_DATA[i].DETAIL_DATA === "String")) {
                    //        rawData.ASSET_INFO_SYNC_LOG_DATA[i].DETAIL_DATA = JSON.parse(rawData.ASSET_INFO_SYNC_LOG_DATA[i].DETAIL_DATA);
                    //    }
                    //}
                    //data.rawDataJSON = JSON.parse(JSON.stringify(rawData));
                    //    data.rawDataJSON = rawData;
                    //} catch (ex) {
                    //    console.log(ex);
                    //}

                    if (!data) {
                        alert('Không tìm thấy bản ghi log này.');
                        this.back();
                        return;
                    }

                    vm.assetInfoSync = data;
                });
            },
            showDetail(item, index, button) {
                this.$services.get(`logging/asset-info-sync-logs/${this.logId}/data/${item.id}`).done(response => {
                    this.infoModal.title = `Thông tin dữ liệu được đồng bộ`;
                    this.infoModal.content = response;
                    this.$root.$emit('bv::show::modal', this.infoModal.id, button);
                });
            },
            showError(item, index, button) {
                this.infoModal.title = `Thông tin lỗi đồng bộ`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            back() {
                this.$router.push({ path: '.' });
            },
            getTargetPath(value) {
                if (this.assetInfoSync.infoTypeId <= 6) { // asset mutations
                    return `/data/asset-mutations/${value}`;
                } else if (this.assetInfoSync.infoTypeId == 7) { // asset inventory
                    return `/data/asset-inventories/${value}`;
                } else if (this.assetInfoSync.infoTypeId == 15) { // national public asset
                    return `/data/national-public-assets/${value}`;
                } else if (this.assetInfoSync.infoTypeId == 16) { // national public asset handling
                    return `/data/national-public-asset-handlings/${value}`;
                } else {
                    return value;
                }
            },
            searchData() {
                this.$refs.assetSyncLogDataTable.refresh();
            },
            getKeyName(key) {
                var col = this.assetComments.find(x => x.columnName == key);

                if (col) {
                    if (!col.comments) return key;

                    var index = col.comments.indexOf('.');
                    return index == - 1 ? col.comments : col.comments.substr(0, index);
                } else {
                    return key;
                }
            },
            getAssetPath(assetTypeGroupId, assetId) {
                var assetPath = "";
                switch (assetTypeGroupId) {
                    case 1:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                        assetPath = '/data/organization-assets/' + assetId; break;
                    case 21:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                        assetPath = '/data/infrastructure-assets/ctns/' + assetId; break;
                    case 22:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 45:
                    case 46:
                    case 47:
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                        assetPath = '/data/infrastructure-assets/htgtdb/' + assetId; break;
                }
                return assetPath;
            }
        },
        watch: {
            logId() {
                this.loadLogDetail();
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
